export enum Gender {
  Male = 1,
  Female = 2,
  Diverse = 3
}

export type UserRole = {
  id: number
  name: string
  guid: string
}

export type User = {
  id: number
  guid: string
  email: string
  vorname: string
  nachname: string
  telefonnummer: string
  geschlecht: Gender
  geburtstag: string
  erstellungsdatum: string
  aktualisierungsdatum: string
  refSalonId: number
  rollen: UserRole[] | null
  newsletter: boolean
  datenschutz: boolean
  kommentarIntern: string | null
  badges: any[]
  devicesList: any[] | null
  devices: boolean
  aktiv: boolean
  terminCount: number
  terminStornoCount: number
  rolle: any | null
  sperre: boolean
  nachrichten: string[] | null
}

export enum UserActionTypes {
  USER_LOGIN = '@@user/USER_LOGIN',
  USER_LOGOUT = '@@user/USER_LOGOUT',
  SET_USER_LOADING = '@@user/SET_USER_LOADING',
  SET_USER_ERROR = '@@user/SET_USER_ERROR'
}

export interface UserState {
  readonly userData: User | null
  readonly isLoggedIn: boolean
  readonly loading: boolean
  readonly error: string
}
